import React , {Component} from 'react';
import AppUtils from '../../apputils';
import { UserDetail } from '../../models/users';
import { PnkConnect } from '../../pnk-react/pnk-miniredux';
import ReferralPage from './referral';


class referral extends Component { 
    constructor(){
        super();
        this.state={
            getUserInfo:true,
            referralCount:''
        }
    }

    HandleRouting = (route) => {
        AppUtils.HandlePageClick(this.props.componentprops, route)
      }

      HandleGetUserDetailsSuccessResponse = (res)=>{
          if(res !== false){
              console.log(res)

              this.setState({
                  referralCount:res.data.userdetails.rows[0].referral_count,
                  getUserInfo:false
              })
          }

          else{
            this.setState({
                getUserInfo:false
            })
            
          }
      }


    render(){
        return(
            <div>
            {localStorage.getItem('current_user_id') !== undefined && localStorage.getItem('current_user_id') !== null && localStorage.getItem('current_user_id') !== '' ?
            <ReferralPage {...this.props} HandleRouting={this.HandleRouting} mystate={this.state}/>
             :
             AppUtils.HandlePageClick(this.props.componentprops, 'login')
            }
            {((this.state.getUserInfo === true) ? UserDetail(this.props.PnkStore, localStorage.getItem('current_user_id'), this.HandleGetUserDetailsSuccessResponse) : "")}
            </div>
        )
    }
}


export const Referral = PnkConnect(referral , '');